import React from 'react';
import Grid from '@material-ui/core/Grid';
import MDXParser from '../mdxParser';
import Img from '../wrappedImage';
import { useStaticQuery, graphql } from 'gatsby';

// Content
import ChangingLives from '../../sections/ChangingLives/ChangingLives';
import ChangingLivesTwo from '../../sections/ChangingLives/ChangingLivesTwo';
import ChangingLivesThree from '../../sections/ChangingLives/ChangingLivesThree';
import Nutrition from '../../sections/ChangingLives/Nutrition';
import ClimateChange from '../../sections/ChangingLives/ClimateChange';
import SchoolFeeding from '../../sections/ChangingLives/SchoolFeeding';
import SmalltimeFarmers from '../../sections/ChangingLives/SmalltimeFarmers';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '60px 0',
    },
    rootDetail: {},
    text: {
      padding: '0px 20px',
      display: 'flex',
      backgroundColor: 'transparent',
      flexDirection: 'column',
      boxShadow: 'none',
      borderRadius: '0px',
    },
    image: {
      width: '100%',
      height: 'auto',
    },
    imageContainer: {
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: 'none',
    },
    imageContainered: {
      display: 'flex',
    },
  }),
);

type Props = { children: React.ReactNode; image: string };

const ChangingLivesSection = () => {
  const classes = useStyles();

  const data = useStaticQuery(graphql`
    query {
      nutritionCrop: file(relativePath: { eq: "nutritionCrop.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      farmers: file(relativePath: { eq: "farmers.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      climateChange: file(relativePath: { eq: "climateChange.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      schoolFeeding: file(relativePath: { eq: "schoolFeeding.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      nutrition: file(relativePath: { eq: "nutrition.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <MDXParser>
            <ChangingLives />
          </MDXParser>
        </Grid>

        <Grid item xs={12} md={6}>
          <MDXParser>
            <ChangingLivesTwo />
          </MDXParser>
        </Grid>

        <Grid item xs={12} md={6}>
          <MDXParser>
            <ChangingLivesThree />
          </MDXParser>
        </Grid>

        <Grid item xs={12} md={6} className={classes.imageContainered}>
          <Img
            fluid={data.climateChange.childImageSharp.fluid}
            className={classes.image}
            alt="Image"
            copyText="WFP"
          />
        </Grid>

        <Grid item xs={12} md={6} className={classes.imageContainered}>
          <Img
            fluid={data.schoolFeeding.childImageSharp.fluid}
            className={classes.image}
            alt="Image"
            copyText="Cecilia Aspe"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <MDXParser>
            <ClimateChange />
          </MDXParser>
        </Grid>

        <Grid item xs={12} md={6}>
          <MDXParser>
            <SchoolFeeding />
          </MDXParser>
        </Grid>

        <Grid item xs={12} md={6} className={classes.imageContainered}>
          <Img
            fluid={data.nutrition.childImageSharp.fluid}
            className={classes.image}
            alt="Image"
            copyText="WFP/Kathleen McCarthy"
          />
        </Grid>

        <Grid item xs={12} md={6} className={classes.imageContainered}>
          <Img
            fluid={data.farmers.childImageSharp.fluid}
            className={classes.image}
            alt="Image"
            copyText="WFP"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <MDXParser>
            <Nutrition />
          </MDXParser>
        </Grid>

        <Grid item xs={12} md={6}>
          <MDXParser>
            <SmalltimeFarmers />
          </MDXParser>
        </Grid>
      </Grid>
    </div>
  );
};

export default ChangingLivesSection;
